module.exports = __webpack_public_path__ + "img/predictile-logo-square.72edbea6.png";